import React, { useEffect } from 'react';
import PublicLayout from '../components/PublicLayout';
import styles from './AboutPage.module.css';

const HEADLINE = 'Bringing AI to Real Estate: The Story Behind Vates Domus AI';

const PARAGRAPHS = [
  { text: 'When Shep and Halaa started Vates Domus AI, they had a simple goal: make artificial intelligence genuinely useful for real estate professionals.' },
  { text: 'Shep spent more than a decade at Microsoft working with data, cloud technology, artificial intelligence, and emerging AI tools. He also spent two years at Amazon Web Services teaching machine learning and has worked closely with startups to turn new technology into real-world products.' },
  { text: 'Halaa brings more than a decade of software engineering experience, including seven years at Microsoft Azure. Together, they saw an opportunity to take technology that can often feel complicated and make it practical for agents and brokers.' },
  { text: 'That idea became Vates Domus AI, an AI-powered real estate platform designed around the way real estate professionals actually work.' },
  { text: 'Instead of asking agents to become AI experts, Vates Domus AI brings AI directly into familiar real estate tasks.' },
  { text: 'Agents can search for properties using everyday language, explore listings on an interactive map, and select properties they want to compare. They can also have an AI-powered conversation with multiple properties at once—asking questions, comparing listings, summarizing information, or even helping prepare information for a buyer.' },
  { text: 'Vates Domus AI can also help agents build a Comparative Market Analysis. The agent remains in control by choosing the properties they believe are the right comparables, while AI helps analyze the information and create a professional report.' },
  { text: 'For Shep and Halaa, that distinction is important.' },
  { text: "AI isn't there to replace the real estate professional. It's there to give them better tools.", highlight: true },
  { text: 'An experienced agent brings something technology cannot: knowledge of the local market, relationships with clients, experience negotiating deals, and the judgment that comes from working in the industry.' },
  { text: 'Vates Domus AI is focused on helping those professionals spend less time digging through information and more time doing what they do best—working with their clients.' },
  { text: "Built by two longtime technology professionals, Vates Domus AI represents a simple idea: the future of real estate isn't AI replacing agents. It's great agents using AI to become even more effective.", highlight: true },
];

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PublicLayout>
      <div className={styles.aboutPage}>
        <div className={styles.aboutContainer}>
          <div className={styles.aboutContent}>
            <div className={styles.aboutHeaderSection}>
              <h1>About Us</h1>
            </div>

            <div className={styles.aboutBody}>
              <h2 className={styles.aboutHeadline}>{HEADLINE}</h2>
              {PARAGRAPHS.map((p, i) => (
                <p
                  key={i}
                  className={p.highlight ? styles.aboutHighlight : undefined}
                >
                  {p.text}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default AboutPage;
